import globalStyles from '../../../../global.less'
import styles from '../index.less'

const getSty = (str: string) => styles[str]
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty('KeyPoint')} ${cla ? styles[cla] : ''}`}>
    {str}
  </span>
)
const fontBoldUnderline = (str: string) => (
  <span className={`${getSty('KeyPoint')} ${getSty('underline')}`}>{str}</span>
)

export default function ProtocolDPAZHTW() {
  return (
    <div className={`${globalStyles['container']} ${getSty('protocol')}`}>
      <h2 className={getSty('title-h2')}>分銷通資料隱私協定</h2>
      {/* <p className={getSty("explain-title")}>分銷通資料隱私協定</p> */}
      <div className={getSty('item-box')}>
        <span>總則</span>
        <ol>
          <li>
            {fonSizeBold('本協定的完整性')}
            <p>
              本協定包含本{fonSizeBold('總則')}、以下分销通隱私聲明
              {fonSizeBold('（“隱私聲明”）')}和以下分銷通資料處理協定
              {fonSizeBold('（“資料處理協定”，勿與本段定義的“本協定”混淆），')}
              這三者均構成本協定不可分割的組成部分。
            </p>
          </li>
          <li>
            {fonSizeBold('您的同意和零售商的授權')}
            <p className={`${styles['mb-8']} ${styles['mt-8']}`}>
              {fonSizeBold('您在分銷通首次接受本協定，即表示您同意：')}
            </p>

            <p>（1） 小米有權按照隱私聲明中的規定處理您的個人資料；</p>
            <p>
              （2）{fonSizeBold('如果這也是')}您為之使用分銷通的零售商
              {fonSizeBold('（“零售商”）的任何員工首次接受資料處理協定，')}
              並且零售商參與小米為其向最終消費者的售出而提供的激勵項目，
              {fontBoldUnderline('則您：')}
            </p>
            <p>
              {fontBoldUnderline(
                '（i）聲明並保證您已獲得法律或零售商的正式授權，得約束其遵守資料處理協定並得代表零售商指示小米根據資料處理協定處理個人資料，'
              )}
              其中資料處理協定授權小米按照其中的規定代表零售商處理個人資料；
            </p>
            <p>
              {fontBoldUnderline('（ii）特此約束零售商遵守資料處理協定；和')}
            </p>
            <p>
              {fontBoldUnderline(
                '（iii） 承認您和任何其他如(2)(i)所述獲得授權的零售商員工'
              )}
              對小米處理個人資料的{fontBoldUnderline('任何')}指示，
              {fontBoldUnderline(
                '均構成零售商的該等指示，不論這些指示是通過言語還是行為（例如在分銷通內向小米傳輸個人資料）做出的，也不論是明示還是暗示，但沉默始終不構成指示；'
              )}
            </p>
            <p>
              （3） 您對本協定的接受與您在書面上正式簽署本協定具有同等法律效力；
            </p>
            <p>
              {fontBoldUnderline(
                '（4） 您和零售商不能就本協定的適用抗辯稱未能：'
              )}
            </p>
            <p className={`${styles['bold-text']} ${styles['underline']}`}>
              （i） 閱讀、理解並接受其全部內容；或
            </p>
            <p className={`${styles['bold-text']} ${styles['underline']}`}>
              （ii） 正式獲得零售商的授權，使其受資料處理協定的約束；和
            </p>
            <p className={styles['bold-text']}>
              {fontBoldUnderline(
                '（5）對於因您明知或因其他原因而隱瞞或虛假陳述如前文(2)(i)所述的零售商授權（或其缺陷或不存在）而產生、涉及或導致'
              )}
              的所有指控、索賠、訴訟、要求、損害賠償、責任、義務、損失、和解、判決、成本和費用，
              {fontBoldUnderline('您應自費賠償小米並使小米免受損害。')}
            </p>
          </li>
          <li>
            {fonSizeBold('本協定的可分割性')}
            <p>
              如果本協定的任何條款在任何方面無效、非法或不可執行，無論是針對小米、您或零售商（各自稱
              {fonSizeBold('“一方”')}或任意組合稱{fonSizeBold('“各方”')}
              ，但以下資料處理協定另有約定的除外），其餘條款（以及針對其他方的上述條款）的有效性、合法性和可執行性均不應因此而受到影響或損害。
            </p>
          </li>
        </ol>
      </div>
      <div className={getSty('item-box')}>
        <span>分銷通隱私聲明</span>
        <p>
          分銷通為您提供銷售業績展示、激勵計算等服務（包括未來可能出現的任何其他形式的服務提供）。為了實現這些功能，我們可能會收集、處理和共用您的個人資料，如下所示：
        </p>
        <p className={styles['mb-8']}>{fonSizeBold('員工身份驗證')}</p>
        <p>
          分銷通僅對特定人員開放（例如被授權在零售商商店場所工作的員工），並且需要進行身份驗證，以根據您的用戶許可權在分銷通內展示資訊、以及支援您使用分銷通，為此我們
          {fonSizeBold('（“小米”）')}需要收集
          {fonSizeBold(
            '您自願提供的您的小米賬號資訊（包括小米帳號ID）、 姓名、手機號碼、電子郵件位址。'
          )}
        </p>
        <p>{fonSizeBold('這些處理您個人資料的活動的法律依據是您的同意。')}</p>
        <p className={styles['mb-8']}>
          此外，我們將繼續使用上述個人資料以及您提供給我們的其他個人資料，用於店鋪管理和人力資源管理等目的。
          請放心，當我們使用您的個人資料時，我們將嚴格遵守適用法律，並且只會處理必要的最低限度的個人資訊。
          請參考我們位於
          <a href='https://privacy.mi.com/all/languages'>
            https://privacy.mi.com/all/languages
          </a>
          的隱私政策詳細瞭解我們如何處理您的個人資料。
        </p>
      </div>
      <div className={getSty('item-box')}>
        <span>分銷通資料處理協定</span>
        <ol>
          <li>
            {fonSizeBold('目的')}
            <p>
              本資料處理協定僅在小米和零售商（各自稱{fonSizeBold('“一方”')}
              ，共同稱{fonSizeBold('“雙方”')}
              ）之間訂立，而不將上文稱為“您”的用戶作為一方當事人。
              {fonSizeBold(
                '小米既不明知地、又不為自己的目的處理最終消費者的個人資料，並且如果零售商指示其處理該等個人資料，處理將受本資料處理協定約束、系代表零售商而進行、且僅為零售商指示的目的。雙方理解，本資料處理協定以下约定處理個人資料的，均以零售商指示小米處理最終消費者的個人資料為前提。'
              )}
            </p>
            {/* <p>指示小米根據本資料處理協定處理的個人資料。</p> */}
          </li>
          <li>
            {fonSizeBold('角色和合規')}
            <p>
              2.1雙方承認，零售商作為資料控制者，小米作為資料處理者，根據適用的個人資料保護法代表零售商處理某些個人資料。
            </p>
            <p>
              2.2在本資料處理協定中，「資料控制者」是指決定處理個人資料的目的和方式的一方，「資料處理者」是指代表數據控制者處理個人資料的一方。
            </p>
            <p>
              2.3小米應根據本資料處理協定和零售商的合法指示代表零售商處理個人資料。
            </p>
            <p>
              {fonSizeBold(
                '2.4零售商應確保其指示始終符合所有適用的個人資料保護法。'
              )}
              小米如果知悉或合理地認為這些指示違反了任何適用的個人資料保護法，將
              {fontBoldUnderline('無不當遲延地')}通知零售商，
              {fonSizeBold(
                '但小米未通知零售商不應影響零售商對其指示的責任和義務。'
              )}
            </p>
            <p>
              {fonSizeBold(
                '2.5 零售商應確保小米的資料處理活動具有適當的合法依據。'
              )}
            </p>
            <p>
              2.6小米將根據零售商的指示採取必要措施，協助零售商履行其在個人資料保護法下的義務。
            </p>
            <p>
              {fonSizeBold(
                '2.7零售商應獨立承擔因不遵守資料控制者的義務和適用的個人資料保護法律而引起的索賠或損失。'
              )}
            </p>
            <p>
              {fonSizeBold('2.8零售商在此被通知，')}
              由於任何與小米產品相關聯的最終消費者個人資料是對小米本身有價值的資料，
              {fonSizeBold(
                '未經小米書面同意，零售商不得與任何第三方共用任何該等個人資料。'
              )}
            </p>
          </li>
          <li>
            {fonSizeBold('個人資料主體的權利')}
            <p>
              3.1
              {fonSizeBold(
                '零售商應全權負責遵守適用的個人資料保護法規定的有關行使個人資料主體權利的請求的任何義務。'
              )}
              小米應合理協助零售商採取適當的技術和組織措施，以便零售商履行回應此類請求的義務。
            </p>
            <p>
              3.2小米應在收到行使個人資料主體權利的請求后，無不當遲延地通知零售商，並提供處理請求所需的其他相關信息。
            </p>
          </li>
          <li>
            {fonSizeBold('資料洩露')}
            <p>各方：</p>
            <p>
              4.1將無不當遲延地通知另一方對與前者負責的個人資料相關的任何導致或可能導致意外、未經授權或其他非法訪問、傳輸、攔截、使用、披露、更改、組合、銷毀、丟失或其他個人資料的處理的安全漏洞採取措施
              {fonSizeBold('（该等漏洞稱為“資料洩露”），')}和
            </p>
            <p>
              4.2應與另一方合理合作，並採取合理措施協助調查、緩解和補救資料洩露。
            </p>
          </li>
          <li>
            {fonSizeBold('安全')}
            <p>各方應：</p>
            <p>
              5.1根據所有適用的個人資料保護法採取適當的技術和組織措施，以保護個人資料免遭意外或非法破壞、丟失或損壞、更改、未經授權的披露或訪問，以及所有其他非法形式的處理；
            </p>
            <p>
              5.2採取一切必要措施，確保只有為履行其在本資料處理協定下的義務經授權的員工才能訪問個人資料；
            </p>
            <p>
              5.3確保有權訪問個人資料的每位員工都瞭解本資料處理協定和所有適用的個人資料保護法規定的義務；和
            </p>
            <p>
              5.4確保訪問個人資料的任何員工的可靠性，並確保這些人員接受過個人資料保護方面的適當培訓，並已簽訂與個人資料處理相關的保密規定。
            </p>
          </li>
          <li>
            {fonSizeBold('賠償')}
            <p>
              {fonSizeBold(
                '6.1對於因違約方的任何作為或不作為而產生、涉及或導致'
              )}
              的所有指控、索賠、訴訟、要求、損害賠償、責任、義務、損失、和解、判決、成本和費用（包括但不限於律師費和成本），
              {fonSizeBold('違約方應賠償守約方並使守約方免受損害。')}
            </p>
            <p>
              {fonSizeBold(
                '6.2在任何情況下，小米均不對超出零售商根據本協定支付的合同費用的損害賠償承擔責任。'
              )}
            </p>
          </li>
          <li>
            {fonSizeBold('終止')}
            <p>
              在不影響其可能擁有的任何其他權利或補救措施（無論是根據本資料處理協定還是根據法律）的情況下，
              {fonSizeBold('在以下情況下，任何一方均可')}
              通過向另一方送達書面通知{fonSizeBold('立即終止本資料處理協定：')}
            </p>
            <p className={styles['bold-text']}>
              7.1另一方違反了本資料處理協定項下的任何實質義務，並且在可補救的違約行為的情況下，在收到提前30（三十）個日曆日的書面通知后未能糾正違約行為；或
            </p>
            <p className={styles['bold-text']}>
              7.2 《分銷通平臺條款與條件》由雙方正式終止。
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}
